export default "__VITE_ASSET__CDd536Od__"